import React from 'react';
import PropTypes from 'prop-types';
import T from 'i18n-react';
import cx from 'classnames';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import green from '@material-ui/core/colors/green';
import amber from '@material-ui/core/colors/amber';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import WarningIcon from '@material-ui/icons/Warning';
import { withStyles } from '@material-ui/core/styles';

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
};

const styles = (theme) => ({
  success: {
    backgroundColor: green[600],
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  info: {
    backgroundColor: theme.palette.primary.dark,
  },
  warning: {
    backgroundColor: amber[700],
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
});

const MessageBar = (props) => {
  const { classes, message, variant, persist, params, onDismiss, ...other } = props;
  const Icon = variantIcon[variant];

  return (
    <Snackbar
      open
      disableWindowBlurListener={!persist}
      autoHideDuration={!persist ? 5000 : null}
      onClose={onDismiss}
      ContentProps={{
        className: classes[variant],
        'aria-describedby': `message-${variant}`,
      }}
      message={
        <Box display='flex' alignItems='center'>
          <Icon className={cx(classes.icon, classes.iconVariant)} />
          {T.translate(`notifications.${message}`, { params })}
        </Box>
      }
      action={
        <IconButton
          aria-label='Close'
          color='inherit'
          className={classes.close}
          onClick={onDismiss}>
          <CloseIcon className={classes.icon} />
        </IconButton>
      }
      {...other}
    />
  );
};

MessageBar.defaultProps = {
  persist: false,
  params: null,
};

MessageBar.propTypes = {
  classes: PropTypes.object.isRequired,
  message: PropTypes.string.isRequired,
  persist: PropTypes.bool,
  params: PropTypes.any,
  onDismiss: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(['success', 'warning', 'error', 'info']).isRequired,
};

export default withStyles(styles)(MessageBar);
